import React from "react";
import { useIsDesktop } from "../../../hooks/useIsDesktop";
import { useTranslation } from "react-i18next";

const ABOUT_IMG =
  "https://ctscarprotection.com/wp-content/uploads/2025/03/IMG_4172.jpg";

const serviceTags = [
  "เคลือบแก้วคริสตัล",
  "ฟิล์มกันรอย PPF",
  "เคลือบเบาะหนัง",
  "ฟิล์มกรองแสง",
  "ฟิล์มลายหินอ่อน",
  "ดูแลรักษาสี",
  "เคลมประกัน",
  "สีลอกได้",
];

const ThirdSection = () => {
  const isDesktop = useIsDesktop();
  const { t } = useTranslation("thirdPart");

  return (
    <section
      style={{
        backgroundColor: "#F7F7F7",
        padding: isDesktop ? "80px 60px" : "48px 20px",
      }}
    >
      <div
        style={{
          maxWidth: "1100px",
          margin: "0 auto",
          display: "flex",
          flexDirection: isDesktop ? "row" : "column",
          alignItems: "center",
          gap: isDesktop ? "60px" : "32px",
        }}
      >
        {/* Left: Image */}
        <div
          style={{
            flex: isDesktop ? "0 0 45%" : "unset",
            width: isDesktop ? "45%" : "100%",
          }}
        >
          <img
            src={ABOUT_IMG}
            alt="About CTS Car Protection"
            style={{
              width: "100%",
              borderRadius: "14px",
              objectFit: "cover",
              aspectRatio: "4/3",
              display: "block",
            }}
          />
        </div>

        {/* Right: Content */}
        <div style={{ flex: 1 }}>
          <h2
            style={{
              fontSize: isDesktop ? "28px" : "22px",
              fontWeight: 700,
              color: "var(--color-text-primary, #1C1C1C)",
              margin: "0 0 8px",
              lineHeight: 1.4,
            }}
          >
            {"ลูกค้าสมควรได้รับสิ่งที่ดีที่สุดจากเรา"}
          </h2>

          <p
            style={{
              fontSize: isDesktop ? "16px" : "14px",
              fontWeight: 600,
              color: "var(--color-primary, #FF6500)",
              margin: "0 0 16px",
            }}
          >
            {"ผู้บุกเบิกด้านการปกป้องสีรถยนต์ในประเทศไทย"}
          </p>

          <p
            style={{
              fontSize: isDesktop ? "15px" : "14px",
              color: "#555",
              lineHeight: 1.8,
              margin: "0 0 24px",
            }}
          >
            CTS Car Protection
            ให้บริการดูแลและปกป้องรถยนต์ครบวงจรด้วยมาตรฐานระดับสากล
            ตั้งแต่การเคลือบแก้วคริสตัล ฟิล์มกันรอย PPF ฟิล์มกรองแสง
            ไปจนถึงการดูแลรักษาสีรถยนต์อย่างมืออาชีพ
            เรามุ่งมั่นที่จะมอบบริการที่ดีที่สุดให้กับลูกค้าทุกท่าน
          </p>

          {/* Service Tags Grid */}
          <div
            style={{
              display: "grid",
              gridTemplateColumns: "1fr 1fr",
              gap: "10px",
              marginBottom: "24px",
            }}
          >
            {serviceTags.map((tag) => (
              <div
                key={tag}
                style={{
                  backgroundColor: "#fff",
                  border: "1px solid #E5E5E5",
                  borderRadius: "8px",
                  padding: "10px 14px",
                  fontSize: "13px",
                  fontWeight: 500,
                  color: "var(--color-text-primary, #1C1C1C)",
                  textAlign: "center",
                }}
              >
                {tag}
              </div>
            ))}
          </div>

          {/* ISO Badge */}
          <div
            style={{
              display: "inline-flex",
              alignItems: "center",
              gap: "8px",
              backgroundColor: "var(--color-primary, #FF6500)",
              color: "#fff",
              borderRadius: "8px",
              padding: "10px 18px",
              fontSize: "14px",
              fontWeight: 600,
              marginBottom: "12px",
            }}
          >
            {"มาตรฐาน ISO 9001:2015"}
          </div>

          {/* Stats */}
          <div
            style={{
              display: "flex",
              alignItems: "center",
              gap: "8px",
              marginTop: "8px",
            }}
          >
            <span
              style={{
                fontSize: isDesktop ? "32px" : "26px",
                fontWeight: 700,
                color: "var(--color-primary, #FF6500)",
              }}
            >
              10+
            </span>
            <span
              style={{
                fontSize: "15px",
                color: "#555",
                fontWeight: 500,
              }}
            >
              {"ปีประสบการณ์"}
            </span>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ThirdSection;
